<style lang="scss">
    @import "~@/assets/css/var";
    .login-parent {
        height: 100%;
        .panel-back {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 60%;
            background: #157dfa url(~@/assets/img/login-back.png) no-repeat center bottom / 100% auto;

        }
        .panel {
            position: fixed;
            top: 40%;
            bottom: 0;
            left: 0;
            right: 0;
            background: #fff;
            text-align: center;
        }

        .clearfix {
            &:after {
                content: '';
                display: table;
                clear: both;
            }
        }

        .login {
            display: inline-block;
            transform: translateY(-50%);
            text-align: left;
        }

        .login-panel {
            position: relative;
            overflow: hidden;
            border-radius: 15px;
            margin-top: 10px;
            display: flex;
            height: 100%;
            background: #fff;
            align-items: center;
            padding: 120px 70px 70px 70px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, .12);
        }

        .logo {
            position: absolute;
            display: flex;
            align-items: center;
            top: 40px;
            left: 58px;
            font-weight: bold;
            font-size: 16px;
            text-align: center;
            width: 300px;
            justify-content: center;

            img {
                width: 40px;
                margin-right: 15px;
            }
        }

        .el-input__inner {
            border: none;
            border-bottom: 1px solid #d8d8d8;
            border-radius: 0;
        }

        .line {
            position: relative;
            border-left: 1px dashed $border;
            color: #d8d8d8;
            margin: 0 52px;
            align-self: stretch;

            &:after {
                position: absolute;
                /*content: "or";*/
                left: 50%;
                top: 50%;
                padding: 2px;
                background-color: #fff;
                transform: translate(-50%, -50%);
            }
        }

        .go-register {
            text-align: left;
            p {
                font-size: 14px;
                line-height: 30px;
            }
        }

        .code-panel {
            display: flex;

            .el-form-item {
                flex-grow: 1;
            }

            .btn {
                width: 120px;
                margin-left: 15px;
                height: 31px;
                cursor: pointer;
                padding: 0;
                line-height: 31px;
            }
        }

        .el-form-item.is-success .el-input__inner,
        .el-form-item.is-success .el-input__inner:focus,
        .el-form-item.is-success .el-textarea__inner,
        .el-form-item.is-success .el-textarea__inner:focus {
            border-color: $main;
        }
        .login-form .el-form-item__error {
            display: none;
        }

        .switch {
            position: absolute;
            top: 18px;
            right: -37px;
            width: 150px;
            line-height: 30px;
            background: #e5a147;
            transform: rotate(45deg);
            text-align: center;
            color: #fff;
            i {
                transform: rotate(90deg);
                margin-right: 5px;

            }
        }
    }
</style>
<template>
    <div class="login-parent">
        <div class="panel-back"></div>
        <div class="panel">
            <div class="login clearfix">
                <div class="login-panel">
                    <div class="logo">
                        <!--<img src="@/assets/img/logo.png">-->
                        君道CMS管理平台
                    </div>
                    <!--<div class="switch clickable" @click="logType = !logType"><i class="el-icon-sort"></i>{{logType ? '密码登录' : '验证码登录'}}</div>-->
                    <div style="width: 300px">
                        <el-form class="login-form" ref="form" :rules="rules" :model="form" size="normal">
                            <!--手机号-->
                            <el-form-item prop="mobile">
                                <el-input ref="mobile" prefix-icon="el-icon-phone" v-model="form.mobile" placeholder="请输入账号"/>
                            </el-form-item>
                            <!--密码-->
                            <el-form-item prop="password" v-if="logType">
                                <el-input prefix-icon="el-icon-lock" type="password" v-model="form.password" autocomplete="off"
                                          placeholder="请输入登录密码"/>
                            </el-form-item>


                            <!--<div style="text-align: right">-->
                                <!--<el-button type="text" size="normal" style="padding: 0;" @click="goFind">忘记密码？</el-button>-->
                            <!--</div>-->
                            <el-form-item>
                                <el-button type="primary" @click="submitForm" :loading="loading" style="width:100%;margin-top: 15px">提交</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <!--<div class="line"></div>-->
                    <!--<div class="go-register">-->
                        <!--<p>还没有账号：</p>-->
                        <!--<p>-->
                            <!--<el-button type="text" size="normal" @click="goRegister">立即注册<i class="el-icon-right"></i></el-button>-->
                        <!--</p>-->
                    <!--</div>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import variable from '@/util/variable';
    export default {
        data() {
            return {
                imgSrc: '',
                logType: true,  // true-密码登录，false-短信验证码登录

                form: {
                    mobile: process.env.NODE_ENV === 'development' ? '000001' : '',
                    password: process.env.NODE_ENV === 'development' ? 'Jundao123' : '',
                },
                rules: {
                    mobile: [{required: true, message: '请输入账号', trigger: 'blur'}],
                    password: [{required: true, message: '请输入登录密码', trigger: 'blur'}],
                },
                loading: false,
            }
        },
        created() {
            // 捕捉页面按钮回车
            document.onkeydown = () => {
                if(window.event.keyCode === 13){
                    this.submitForm()
                }
            }
        },
        mounted() {
            this.$refs.mobile.focus();
        },
        methods: {

            submitForm() {
                this.$refs['form'].validate(valid => {
                    if (valid) {
                        const param = {
                            userCode: this.form.mobile,
                            password: this.form.password,
                        }

                        this.loading = true;
                        this.$api.post('sys/login/login', param)
                            .then(res => {
                                this.$help.tokenHelp.set(`Bearer ${res.data}`)
                                this.$store.dispatch('setUser')
                                // 赋值当前登录人接口 this.$store.commit('setUser', res)
                                this.$help.success("登录成功");
                                this.$store.commit('setPage', variable.pageType.NORMAL);
                            })
                            .finally(() => {
                                this.loading = false;
                            })
                    }
                })
            },
            goRegister() {
                this.$store.commit('setPage', variable.pageType.REGISTER);
            },
            goFind() {
                this.$store.commit('setPage', variable.pageType.FIND);
            },
        }
    }
</script>

